import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import GenericClickTracker, { useGenericClickTracker } from "../generic-click-tracker/index.js";
import getEventData from "./getEventData/index.js";
export const defaultTrackableSelector = 'a,[data-trackable],[data-trackable-selection]';
const useDefaultEventDataMapper = _ref => {
  let {
    eventData = {},
    product
  } = _ref;
  return React.useCallback((element, contextProperties) => getEventData({
    element,
    eventData,
    product,
    contextProperties
  }), [eventData, product]);
};
export const useClickTracker = _ref2 => {
  let {
    eventData = {},
    product,
    ...props
  } = _ref2;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return useGenericClickTracker({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper,
    ...props
  });
};
const ClickTracker = _ref3 => {
  let {
    product,
    eventData = {},
    ...props
  } = _ref3;
  const defaultEventDataMapper = useDefaultEventDataMapper({
    eventData,
    product
  });
  return /*#__PURE__*/React.createElement(GenericClickTracker, _extends({
    trackableSelector: defaultTrackableSelector,
    eventData: defaultEventDataMapper
  }, props));
};
process.env.NODE_ENV !== "production" ? ClickTracker.propTypes = {
  /**
   * The name of your product
   */
  product: PropTypes.string.isRequired,
  /**
   * Object with event data to report in analytics track call
   */
  eventData: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()])
} : void 0;
export default ClickTracker;